import { render } from "./LogsSubMenu.vue?vue&type=template&id=06016aae"
import script from "./LogsSubMenu.vue?vue&type=script&lang=js"
export * from "./LogsSubMenu.vue?vue&type=script&lang=js"

import exportComponent from "D:\\dev\\mdm-crtwww-vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__